import { createContext, useContext, ReactNode, useMemo, useCallback, useState } from 'react';

interface ProductViewContextValue {
  plateformeKeys: string[]
  handleAddPlateformeKeys: (keys: string[]) => void
}

const ProductViewContext = createContext<ProductViewContextValue | undefined>(undefined);

export const useProductViewContext = () => {
  const context = useContext(ProductViewContext);
  if (context === undefined) {
    throw new Error('useProductViewContext must be used within a ProductViewProvider');
  }
  return context;
};

interface ProductViewProviderProps {
  children: ReactNode;
}

export const ProductViewProvider = ({ children }: ProductViewProviderProps) => {
  const [plateformeKeys, setPlateformeKeys] = useState<string[]>([]);

  const clearSelection = useCallback(() => {
    setPlateformeKeys([]);
  }, []);

  const handleAddPlateformeKeys = useCallback((keys: string[]) => {
    setPlateformeKeys(keys)
  }, [])

  const contextValue = useMemo(() => ({
    plateformeKeys,
    handleAddPlateformeKeys,
    clearSelection,
  }), [handleAddPlateformeKeys, plateformeKeys, clearSelection]);

  return (
    <ProductViewContext.Provider value={contextValue}>
      {children}
    </ProductViewContext.Provider>
  );
};
